const footer = {
  'footer.title': 'footer',
}

export default footer
